import { render, staticRenderFns } from "./MyStudents.vue?vue&type=template&id=3914abfe&scoped=true&"
import script from "./MyStudents.vue?vue&type=script&lang=js&"
export * from "./MyStudents.vue?vue&type=script&lang=js&"
import style0 from "./MyStudents.vue?vue&type=style&index=0&id=3914abfe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3914abfe",
  null
  
)

export default component.exports